import { UPDATE_PROFILE_DETAILS } from './types';

export const updateProfileDetailsAction = (updateProfileDetails,actionType) => dispatch => {
    dispatch({
        type: UPDATE_PROFILE_DETAILS,
        updateProfileDetails: updateProfileDetails,
        actionType:actionType,
    })
}